import Vue from 'vue';
import Router from 'vue-router';
import layout from './components/layout'
Vue.use(Router);

let router=new Router({
    //TODO
    // 1、hash哈希：有#号。2、history：没有#号;
    // 2.都是实现路由的两种模式
    // 3.history需要后端配合，否则刷新页面会报404;url 会在浏览器中有记录栈
    // 4.history是利用浏览历史记录栈的API实现；hash是监听location对象hash值变化事件来实现(不是很明白)
    mode:"hash",
    base:process.env.BASE_URL,
    //记录滚动的位置解决白屏问题，必须配合keep-alive
    scrollBehavior(to,from,position){
        if(position){
            return position
        }else{
            return {x:0,y:0}
        }
    },
    routes:[
        {
            path:"/",
            name:"index",
            component:layout,
            meta:{title:"layout",keepAlive:false},
            redirect: '/index',
            children:[
                {
                    path:"/index",
                    name:"index",
                    component:()=>import("./pages/index/index"),
                    meta:{title:"首页",keepAlive:false},
                },
                {
                    path:"/about",
                    name:"about",
                    component:()=>import("./pages/about/index"),
                    meta:{title:"关于我们",keepAlive:false}
                },
                {
                    path:"/introduce",
                    name:"introduce",
                    component:()=>import("./pages/introduce/index"),
                    meta:{title:"平台介绍",keepAlive:false}
                },
                {
                    path:"/newStatus",
                    name:"newStatus",
                    component:()=>import("./pages/newStatus/index"),
                    meta:{title:"",keepAlive:false},
                },
                {
                    path:"/newStatus/companyAnnouncement",
                    name:"companyAnnouncement",
                    component:()=>import("./pages/newStatus/companyAnnouncement"),
                    meta:{title:"",keepAlive:false},
                },
                {
                    path:"/newStatus/jinKongAnnouncement",
                    name:"jinKongAnnouncement",
                    component:()=>import("./pages/newStatus/jinKongAnnouncement"),
                    meta:{title:"",keepAlive:false},
                }
            ]
        },

    ]
});

router.beforeEach((to,from,next)=>{
    if(to.meta.auth){
        if(Boolean(localStorage['isLogin'])){
            next();
        }else{
            next("/login");
        }
    }else {
        next();
    }
});

export default router;
